// extracted by mini-css-extract-plugin
export var blogMediaCard = "styles-module--blog-media-card--2606e";
export var ctaSections = "styles-module--cta-sections--be8bf";